module.exports = __webpack_public_path__ + "img/at.3ffaa31f.svg";